import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import {
  getMerchants,
  getAllPlaces
} from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import { CSVLink } from 'react-csv';
import { BiSolidFileExport } from 'react-icons/bi';

const MerchantIndex = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: {
      MerchantLists,
      merchantCount,
      places
    },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [place, setPlace] = useState("");
  const [sort, setSort] = useState('desc');
  const [isApproved, setIsApproved] = useState([]);
  const [approved, setApproved] = useState("");
  const [paginate, setPaginate] = useState(10);
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  useEffect(() => {
    dispatch(getMerchants(auth?.token, paginate, page, search, place, sort, approved))
  }, [auth, paginate, page, search, place, sort, approved]);

  useEffect(() => {
    dispatch(getAllPlaces(auth.token));
  }, [auth]);

  const csvHead = [['place', 'name', 'mobile', 'email', 'company name', 'website url', 'address', 'pincode', 'city', 'state', 'country', 'description']]
  const csvData = MerchantLists.map((cv) => [
    cv?.place?.place_name,
    cv?.name,
    cv?.mobile,
    cv?.email,
    cv?.company_name,
    cv?.website_url,
    cv?.address,
    cv?.pincode,
    cv?.city?.city_name,
    cv?.state?.state_name,
    cv?.country,
    cv?.description,
  ])
  const exportData = csvHead.concat(csvData);

  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Merchant")) {
      axios
        .delete(`/api/admin/v1/merchant-delete/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getMerchants(auth?.token));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };

  useEffect(() => {
    if (MerchantLists?.length) {
      setIsApproved(
        MerchantLists?.map?.((item) => {
          return { id: item.id, is_approved: item?.is_approved };
        })
      );
    }
  }, [MerchantLists]);

  const handleApprovalChange = useCallback(
    (val, id) => {
      setIsApproved((prev) =>
        prev.map((item) => {
          if (item.id === id) {
            return { ...item, isApproved: val };
          }
          return item;
        })
      );
      axios
        .put(
          `/api/admin/v1/update-merchant-approval/${id}`,
          { isApproved: val },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then((res) => {
          toast.success(res.data?.message);
          dispatch(getMerchants(auth?.token));
        })
        .catch((err) => toast.error(err.response.data?.message));
    },
    [isApproved, auth]
  );

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between" >
            <h5 className="mb-0 text-white fs-4">Merchant List</h5>
            {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "MERCHANTS" && item?.permission?.permission === "create") && (
              <Link to="/add-merchant">
                <Button className="bg-white text-black" size="sm">
                  <span className="me-2">
                    <MdAdd size={22} />
                  </span>
                  Add Merchant
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>

        <div className="row">
          <div className="col-md-3 mb-2">
            <Input size={"sm"} value={search} placeholder='Search By Name, Email, Mobile Or Company Name' onChange={(({ target: { value } }) => setSearch(value))} />
          </div>
          <div className="col-md-2">
            <Input size={"sm"}
              type="select"
              name="place"
              value={place} onChange={(({ target }) => setPlace(target.value))}
            >
              <option value="">Select Place</option>
              {places?.map?.((item) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item?.place_name}
                  </option>
                );
              })}
            </Input>
          </div>
          <div className="col-md-2">
            <Input type="select" size={"sm"} value={approved} onChange={(({ target }) => setApproved(target.value))} >
              <option value="">Select Approval</option>
              <option value="0">Pending</option>
              <option value="1">Approved</option>
              <option value="2">Rejected</option>
            </Input>
          </div>
          <div className={`col-md-2 ${allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "MERCHANTS" &&
              item?.permission?.permission === "export"
          ) ? "offset-md-2" : "offset-md-3"}`}>
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "MERCHANTS" && item?.permission?.permission === "export") && (
            <div className="col-md-1 mb-2">
              <CSVLink
                filename={
                  "merchant-lists.csv"
                }
                className="text-black ms-1"
                title="Export To CSV"
                data={exportData}
              >
                <BiSolidFileExport size={25} />
              </CSVLink>
            </div>
          )}
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>Place</th>
                  <th>Name</th>
                  <th>mobile</th>
                  <th>Thumbnail</th>
                  <th>Company Name</th>
                  <th>Address</th>
                  <th>Website</th>
                  <th>Approval Status</th>
                  {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "MERCHANTS" && (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")) && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {MerchantLists.length === 0 ? (
                  <tr>
                    <td colSpan="6">No data found</td>
                  </tr>
                ) : (<>
                  {MerchantLists?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>
                        <th scope="row">{index + 1 + page * paginate}</th>
                        <td>{item?.place?.place_name}</td>
                        <td>{item?.name}</td>
                        <td>{item?.mobile}</td>
                        <td>
                          {item?.thumbnail ? (
                            <img
                              src={process.env.REACT_APP_IMAGE_URL + `/${item?.thumbnail}`}
                              height={45}
                              width={45}
                            />
                          ) : null}
                        </td>
                        <td>{item?.company_name}</td>
                        <td>{item?.address}</td>
                        <td>
                          {item.website_url ? (
                            <a
                              href={item?.website_url}
                              target="_blank"
                            >
                              {item?.website_url}
                            </a>
                          ) : null}
                        </td>
                        <td>
                          <Input
                            type="select"
                            value={
                              isApproved.find((it) => it.id === item.id)?.is_approved
                            }
                            onChange={({ target: { value } }) =>
                              handleApprovalChange(value, item.id)
                            }
                          >
                            <option value="0">Pending</option>
                            <option value="1">Approved</option>
                            <option value="2">Rejected</option>
                          </Input>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "MERCHANTS" &&
                                item?.permission?.permission === "edit"
                            ) && (
                                <Link to={`/edit-merchant/${item?.id}`}>
                                  <AiOutlineEdit
                                    size={22}
                                    className="text-warning me-3"
                                  />
                                </Link>
                              )}
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "MERCHANTS" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete
                                  size={22}
                                  className="text-danger"
                                  onClick={() => handleDel(item.id)}
                                />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                onChange={e =>
                  setPaginate(
                    e.target.value
                  )
                }
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value="10">
                  10
                </option>
                <option value="20">
                  20
                </option>
                <option value="50">
                  50
                </option>
                <option value="100">
                  100
                </option>
                <option value="200">
                  200
                </option>
                <option value="500">
                  500
                </option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {merchantCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, merchantCount)} of {merchantCount} entries
                </>
              ) : (
                <>
                  Showing 0 to 0 of 0 entries
                </>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination
                pageCount={(merchantCount) / paginate}
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantIndex;
